import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import "./CTA.css";
import { NavLink } from "react-router-dom";
import TechnologyModal from "../technologyModal/TechnologyModal";

export default function CTA({
  heading,
  href,
  btnText,
  onClick,
  click,
  data,
  href2,
  secondBtn,
  href3,
  btnText2,
  href4,
}) {
  const [showModal, setShowModal] = useState(false);
  return (
    <>
      <TechnologyModal
        href={href4}
        show={showModal}
        onHide={() => setShowModal(false)}
      />
      <div className="cta-container text-center">
        <Row className="align-items-center justify-content-center">
          <Col md={12}>
            <h2 className="container-title mb-4 text-center">{heading}</h2>
            {href && (
              <NavLink to={href} className="d-inline-block me-2">
                {btnText}{" "}
              </NavLink>
            )}

            {secondBtn && (
              <NavLink onClick={onClick} className="d-inline-block " to={href3}>
                {btnText2}{" "}
              </NavLink>
            )}
            {href2 && (
              <a href={href2} target="_blank" rel="noopener noreferrer">
                {btnText}{" "}
              </a>
            )}

            {href4 && (
              <button

                onClick={() => setShowModal(true)}
              >
                View APIs
              </button>
            )}
            {click && <button onClick={onClick}>{btnText} </button>}
          </Col>
        </Row>
      </div>
    </>
  );
}
